module.exports = __webpack_public_path__ + "static/kataai-5b53e2acfe08287b51d09c48849868bd.svg";